/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 */
import Reveal from "./Reveal";
import { FEATURES } from "./landing.data";

export default function WhySection({ isArabic }) {
  return (
    <section className="gl-section" id="why">
      <div className="gl-shell">
        <Reveal className="gl-head">
          <p className="gl-eyebrow">
            {isArabic ? "لماذا مدار المجرة؟" : "Why Madar Galaxy?"}
          </p>
          <h2 className="gl-title">
            {isArabic
              ? "بنية تقنية تُحلّق بتجارتك"
              : "Infrastructure built to scale commerce"}
          </h2>
          <p className="gl-lead">
            {isArabic
              ? "كل ما تحتاجه لإدارة متجر احترافي — بسرعة، أمان، ورؤية واضحة للنمو."
              : "Everything you need to run a professional store — with speed, security, and clarity to grow."}
          </p>
        </Reveal>

        <div className="gl-features">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <Reveal key={f.titleEn} delay={i * 0.06}>
                <article className="gl-feature">
                  <div className="gl-feature__icon">
                    <Icon size={22} strokeWidth={2} />
                  </div>
                  <h3 className="gl-feature__title">
                    {isArabic ? f.titleAr : f.titleEn}
                  </h3>
                  <p className="gl-feature__desc">
                    {isArabic ? f.descAr : f.descEn}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
